// extracted by mini-css-extract-plugin
export var background = "hero-module--background--NtVSN";
export var buttonContainer = "hero-module--buttonContainer--oLL2t";
export var heading = "hero-module--heading--oWLur";
export var image = "hero-module--image--hF4vf";
export var section = "hero-module--section--1wJl2";
export var show = "hero-module--show--9s3ZW";
export var small = "hero-module--small--DJDX3";
export var subheading = "hero-module--subheading--D8aZ1";